module.exports = __webpack_public_path__ + "static/media/scwhite.a19cabc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/scwhite.jpg
// module id = 151
// module chunks = 0